
document.addEventListener("DOMContentLoaded", function () {

  function replaceText(node) {
    if (node.nodeType === 3) { // Text node
      node.nodeValue = node.nodeValue.replace(/90[-\s]?days?/gi, function(match) {
        return match.toLowerCase().includes('day') ? '30-Day' : match;
      });
    } else {
      node.childNodes.forEach(replaceText);
    }
  }

  replaceText(document.body);

  function getHeaderOffset() {
    const stickyHeader = document.querySelector('.section-header, .header-wrapper, sticky-header');
    if (!stickyHeader) return 0;
    const rect = stickyHeader.getBoundingClientRect();
    return Math.max(0, Math.round(rect.height));
  }

  function scrollToReviews() {
    const target =
      document.querySelector('[id^="DentiteReviews-"]') ||
      document.getElementById('judgeme_product_reviews');

    if (!target) return;

    const y = window.pageYOffset + target.getBoundingClientRect().top - getHeaderOffset() - 12;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target && e.target.closest ? e.target.closest('.hb-banner-rating') : null;
    if (!trigger) return;

    e.preventDefault();
    scrollToReviews();
  });

});

